import React from "react"
import CuratedHotelPage from "../../templates/hotels/CuratedHotelPage"

const Page = () => <CuratedHotelPage hotelKey="comoCastelloDelNero" locale="en" />

export default Page
